'use client'
import * as React from 'react'
import { CommitIcon } from '@radix-ui/react-icons'

import { BubbledBox } from '~/components/bubbled-box'
import { Portal } from '~/components/portal'
import { ButtonLink } from '~/sotano-kit/primitives/button'
import { clsx } from 'clsx'
import { useSelectedTeamAndRepo } from '~/hooks-data/use-selected-team-and-repo'

export const CommitEmptyState = ({
  className,
  redirectTo = 'explore',
}: {
  className?: string
  redirectTo?: 'explore' | 'team'
}) => {
  const { team, repo } = useSelectedTeamAndRepo().data ?? {}
  if (!repo || !team) return null

  return (
    <Portal
      id="commit-empty-state"
      className={clsx(
        className,
        'pointer-events-auto flex flex-col items-center justify-center bg-dark-bg p-5'
      )}
    >
      <BubbledBox disabled className="mb-8 rounded-[20px] p-[18px]">
        <CommitIcon
          width={62}
          height={62}
          className="relative z-40 text-dark-faint"
        />
      </BubbledBox>

      <p className="mb-2 text-sm font-medium leading-4">No commits yet</p>
      <p className="text-[13px] leading-4 text-dark-muted">
        {redirectTo === 'explore' ? (
          <>
            Go back to your{' '}
            <ButtonLink
              href={`/${team.slug}/${repo.slug}/explore`}
              unstyled
              className="text-dark-control-base hover:underline"
            >
              content
            </ButtonLink>
            .
          </>
        ) : (
          <>
            Go back to{' '}
            <ButtonLink
              href={`/${team.slug}`}
              unstyled
              className="text-dark-control-base hover:underline"
            >
              "{team.title}" team
            </ButtonLink>
            .
          </>
        )}
      </p>
    </Portal>
  )
}
